import Form from '../../components/form';

const crmOrderCreation = document.querySelector('.j-crm-order-creation');

if (crmOrderCreation) {
    const form = new Form();

    form.init({
        target         : crmOrderCreation,
        successMessage : true,
        successCallback: (responseData) => {
            if (!responseData.data?.redirect_url) {
                return;
            }
            location.pathname = responseData.data.redirect_url;
        }
    });
    form.send();
}
